import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  cursor: pointer;
  opacity: ${(props) => (props.isDisabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'all')};

  div {
    margin-right: 1rem;
  }
`;

export const FormContainer = styled.div`
  opacity: ${({ isDisabled }) => (isDisabled ? 0.4 : 1)};
  cursor: ${({ isDisabled }) => (isDisabled ? 'wait !important' : 'default')};

  ${({ isDisabled }) =>
    isDisabled &&
    `
    * {
    pointer-events: none;
    }
  `}
`;

export const ErrorMessage = styled.div`
  margin-top: 1em;
  color: ${({ theme }) => theme.base.red};
`;

export const Radios = styled.div`
  margin-left: 40px;
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
`;
